module.exports={"Clear search":"清除搜索"};